import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function operacaobloqueioprefaturageradaitem(
  state = INITIAL_STATE,
  action
) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@operacaobloqueioprefaturageradaitem/FIND_BLOQUEIOVEICULOS':
        case '@operacaobloqueioprefaturageradaitem/FIND_VEICULOSPREGERADA':
      case '@operacaobloqueioprefaturageradaitem/UPDATE_BLOQUEIOVEICULOS':
      case '@operacaobloqueioprefaturageradaitem/DELETE_BLOQUEIOVEICULOS':
      case '@operacaobloqueioprefaturageradaitem/STORE_BLOQUEIOVEICULOS':
      case '@operacaobloqueioprefaturageradaitem/BLOQUEIOVEICULOS_IN_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@operacaobloqueioprefaturageradaitem/SUCCESS_REMOVE':
      case '@operacaobloqueioprefaturageradaitem/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@operacaobloqueioprefaturageradaitem/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.operacaobloqueioprefaturageradaitem;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@operacaobloqueioprefaturageradaitem/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.operacaobloqueioprefaturageradaitem;
        break;
      }

      case '@operacaobloqueioprefaturageradaitem/RECORD_FILTERING':
        case '@operacaobloqueioprefaturageradaitem/RECORD_FILTERING_VEICULO': {
        draft.loading = true;
        //draft.params = { ...draft.params, ...action.payload.params };
        draft.params = action.payload.params;
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
